module.exports = __webpack_public_path__ + "static/media/filter.7ee3e627.svg";